import { render, staticRenderFns } from "./UpsertCustomTargeting.vue?vue&type=template&id=dd95a994&scoped=true"
import script from "./UpsertCustomTargeting.vue?vue&type=script&lang=js"
export * from "./UpsertCustomTargeting.vue?vue&type=script&lang=js"
import style0 from "./UpsertCustomTargeting.vue?vue&type=style&index=0&id=dd95a994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd95a994",
  null
  
)

export default component.exports